import {
  NO_CREDIT_MESSAGE,
  NO_CREDIT_STATUS_CODE,
} from '@lessonPlanner/constants';
import {
  ErrorDetails,
  ErrorWithCode,
  getErrorMessage,
} from '../components/organisms/ErrorModalDetails';

interface ErrorHandlerResult {
  isNoCreditsError: boolean;
  hasError: boolean;
  errorDetails: ErrorDetails | null;
}

export const handleResponseError = (
  error: ErrorWithCode,
): ErrorHandlerResult => {
  const isNoCreditsError =
    error.statusCode === NO_CREDIT_STATUS_CODE ||
    error.message === NO_CREDIT_MESSAGE;

  const hasError = error.name !== 'AbortError';
  const errorDetails = hasError ? getErrorMessage(error) : null;

  console.error('Error details:', error);

  return {
    isNoCreditsError,
    hasError,
    errorDetails,
  };
};
